// Sem shared config de ApexCharts em lugar nenhum do projeto hoje (cada tela
// monta seu `options` do zero, com pequenas divergências de cor/formatação) —
// este arquivo é novo, escopo só do Dashboard Consolidado por enquanto.

const PALETA = ['#0B5FA8', '#3E7D5A', '#A5670F', '#545454', '#77B6EA', '#eb8989'];

function formatarNumeroPtBr(valor) {
    if (valor === null || valor === undefined || !Number.isFinite(valor)) return '-';
    return valor.toLocaleString('pt-BR', { maximumFractionDigits: 2, style: 'decimal' });
}

// O ApexCharts chama o formatter de dataLabels com assinaturas diferentes por
// tipo de gráfico: em barra/linha o 1º argumento é o valor numérico do ponto;
// no treemap é o texto da categoria (nome da caixa) — formatarNumeroPtBr nesse
// caso sempre cai no "-" (Number.isFinite de uma string é sempre falso), então
// as caixas do treemap nunca mostravam nome nem valor.
function dataLabelsFormatter(tipo) {
    if (tipo === 'treemap') {
        return (texto, opcoes) => [texto, formatarNumeroPtBr(opcoes.value)];
    }
    return formatarNumeroPtBr;
}

function corComOpacidade(hex, alpha) {
    let valor = hex.replace('#', '');
    let r = parseInt(valor.substring(0, 2), 16);
    let g = parseInt(valor.substring(2, 4), 16);
    let b = parseInt(valor.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Usado pelo ComparativoUnidadeMes pra destacar visualmente o mês selecionado
// no filtro "Mês" -- esse gráfico é uma série anual e não filtra dados por
// `mes` como os outros widgets do Dashboard Consolidado (recolher pra uma
// barra só destruiria a visão de tendência que é o motivo dele existir), mas
// sem nenhum feedback visual isso parecia bug (o filtro "não fazia nada" nesse
// gráfico específico). `indiceDestaque` -1/undefined = sem destaque, paleta
// normal (mesmo comportamento de antes). ApexCharts aceita `colors` como array
// de funções (uma por série, recebe `{dataPointIndex}`) pra colorir cada barra
// individualmente.
function paletaComDestaque(paleta, numSeries, indiceDestaque) {
    let cores = Array.from({ length: numSeries }, (_, i) => paleta[i % paleta.length]);
    if (indiceDestaque === undefined || indiceDestaque === -1) return cores;
    return cores.map((corBase) => ({ dataPointIndex }) => (
        dataPointIndex === indiceDestaque ? corBase : corComOpacidade(corBase, 0.25)
    ));
}

// Mesmo raciocínio pros rótulos de valor: com um mês destacado, mostra o
// número só na(s) barra(s) daquele mês -- os demais ficam sem rótulo, o que
// reduz a poluição visual em vez de competir por contraste com barras já
// esmaecidas por `paletaComDestaque`.
function formatterComDestaque(indiceDestaque) {
    return (valor, opcoes) => {
        if (indiceDestaque !== undefined && indiceDestaque !== -1 && opcoes.dataPointIndex !== indiceDestaque) return '';
        return formatarNumeroPtBr(valor);
    };
}

function optionsBase({ titulo, tipo }) {
    return {
        chart: { type: tipo, toolbar: { show: false } },
        colors: PALETA,
        title: { text: titulo, align: 'left' },
        tooltip: {
            shared: true,
            intersect: false,
            y: { formatter: formatarNumeroPtBr },
        },
        dataLabels: {
            formatter: dataLabelsFormatter(tipo),
        },
        legend: { position: 'bottom', horizontalAlign: 'center' },
    };
}

export default { PALETA, formatarNumeroPtBr, optionsBase, corComOpacidade, paletaComDestaque, formatterComDestaque };
